<template>
  <button @click="list" type="button"
          class="btn btn-sm btn-secondary mr-1">
    <font-awesome-icon icon="list"/>&nbsp;{{ $t('listOfTemplates') }}
    <b-modal modal-class="modal-fullscreen" content-class="modal-content-2" size="xl" header-class="pb-0" min
             header-bg-variant="white"
             v-model="showList" hide-footer ok-only no-close-on-backdrop no-enforce-focus>
      <template #modal-title>
        <font-awesome-icon icon="list"/>&nbsp;{{ $t('listOfTemplates') }}
      </template>
      <z-n-s-template-list :zaloOA="zaloOA"></z-n-s-template-list>
    </b-modal>
  </button>
</template>

<script>
import ZNSTemplateList from "@/views/zns/ZNSTemplateList.vue";

export default {
  components: {ZNSTemplateList},
  props: {
    zaloOA: Object,
  },
  data() {
    return {
      showList: false,
    }
  },
  methods: {
    list() {
      this.showList = true;
    },
  },
  i18n: {
    messages: {
      en: {
        listOfTemplates: "List of Templates",
      },
      vi: {
        listOfTemplates: "Danh sách Template",
      }
    }
  }
}
</script>

<style>
.modal-fullscreen .modal-dialog {
  max-width: 98%;
}
</style>